import { render, staticRenderFns } from "./PieceJointeForm.vue?vue&type=template&id=40bbc89f&"
import script from "./PieceJointeForm.vue?vue&type=script&lang=js&"
export * from "./PieceJointeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports